import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingPlaceholder from './LoadingPlaceholder';
import { Tooltip, OverlayTrigger } from 'react-bootstrap'; // Import Bootstrap components

const LivePayouts = () => {
    const [livePayouts, setLivePayouts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const url = `${site['site_url']}/ajax/tsw.core.php?action=get.LivePayouts`;
            try {
                const response = await axios.post(url, {}, { withCredentials: true });
                if (response.data.status === 'success') {
                    const livePayoutsArray = Object.values(response.data.data);
                    setLivePayouts(livePayoutsArray);
                } else {
                    setError('No data available.');
                }
            } catch (error) {
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return <LoadingPlaceholder />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="js-nav-scroller hs-nav-scroller-horizontal">
            <span className="hs-nav-scroller-arrow-prev" style={{ display: 'none' }}>
                <a className="hs-nav-scroller-arrow-link">
                    <i className="bi-chevron-left"></i>
                </a>
            </span>
            <span className="hs-nav-scroller-arrow-next" style={{ display: 'none' }}>
                <a className="hs-nav-scroller-arrow-link">
                    <i className="bi-chevron-right"></i>
                </a>
            </span>
            <ul className="nav overflow-auto p-0">
                {livePayouts.map((val, index) => (
                    <li key={index} className="nav-item flex-shrink-0 me-2">
                        <OverlayTrigger
                            placement="bottom"
                            overlay={(
                                <Tooltip id={`tooltip-${index}`} html>
                                    <span className='list-unstyled small'>
                                        {val.type == 'offer.earning' ? (
                                            <>
                                                <li>Offername: &nbsp; {val.offername}</li>
                                                <li>Offerwall: &nbsp; <span>{val.offerwall}</span></li>
                                                <li>Reward: &nbsp; {val.reward} COINS(s)</li>
                                                <li>Country: &nbsp; {val.country}</li>
                                            </>
                                        ) : (
                                            <>
                                                <li>Username: &nbsp; {val.username}</li>
                                                <li>Withdrawal: &nbsp; <span>{corePLK.getGatewayInfo(val.withdrawal).name}</span></li>
                                                <li>Amount: &nbsp; {val.amount} COINS(s)</li>
                                                <li>Country: &nbsp; {val.country}</li>
                                            </>
                                        )}
                                    </span>
                                </Tooltip>
                            )}
                        >
                            <div className="d-flex align-items-center p-2 bg-dark rounded">
                                <div className="d-flex flex-column align-items-center justify-content-center bg-dark rounded-circle text-white me-1 w-25px h-25px">
                                    <img src={coreTSW.getAvatar('dicebear', { name: val.name, style: 'initials' })} alt="User Image" className="img-fluid rounded"/>
                                </div>
                                <div className="ms-2">
                                    <div className="text-muted small fs-10px">
                                        <b>{val.type == 'offer.earning' ? val.title : corePLK.getGatewayInfo(val.title).name}</b>
                                        <br />
                                        {val.title_small}
                                    </div>
                                </div>
                                <div className="small ms-3 bg-light rounded py-1 px-2 d-flex align-items-center">
                                    {val.type == 'offer.earning' ? `$ ${val.payout}` : `${coreTSW.getCurrencyInfo(val.currency).symbol} ${val.payout}`}
                                </div>
                            </div>
                        </OverlayTrigger>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LivePayouts;
